import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ISenderDetails } from '../class/largereceipt';
import { LargereceiptService } from '../service/largereceipt.service';
import { catchError, map } from 'rxjs/operators';
import { CommonUtilService } from '../service/common-util.service';


@Injectable({
  providedIn: 'root'
})
export class SenderdetailsResolver implements Resolve<ISenderDetails> {
  constructor(private largeReceiptSvc: LargereceiptService,private router:Router
    ,private commonUtilService: CommonUtilService
    ) {
      

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ISenderDetails> {
    let messageId = route.paramMap.get('messageId');
    //alert(messageId);
    if(messageId!=undefined)
      localStorage.setItem("MessageId",messageId);
    else if(messageId==undefined && localStorage.getItem("MessageId")!=undefined)
    {
        messageId=localStorage.getItem("MessageId");
    }
    this.commonUtilService.DisplayAndHideSideMenu('receipt-authentication');
    
        if (messageId=='undefined') {
            
          // this.router.navigate(['/ErrorPage','Please enter valid Message id to get sender details']);
          this.router.navigate(['/receipt-authentication']);
            return of (null);
        }
        else{

          return this.largeReceiptSvc.getSenderDetails(messageId)
          .pipe(
           catchError(error => {
             let errorDescription=error;
             this.router.navigate(['/errorpage',error]);
               return of(null);
           })
         );

        }

    


  }
}
